export const INTERNAL_NETWORK_TOOL_NAMES = {
  REMOTE_C2_COMMAND: 'remote_c2_command',
  PASSWORD_AUDIT_CRACK: 'password_audit_crack',
  LIST_AD_ENTITIES: 'list_ad_entities',
  GET_AD_ENTITY_DETAILS: 'get_ad_entity_details',
  GET_AD_ENTITY_RELATIONSHIPS: 'get_ad_entity_relationships',
  QUERY_AD_GRAPH: 'query_ad_graph',
  CREATE_DISCOVERY_SIGNAL: 'create_internal_network_discovery_signal',
  GET_EXISTING_DISCOVERY_SIGNALS:
    'get_existing_internal_network_discovery_signals',
  CREATE_SCENARIO_DRAFT: 'create_internal_network_scenario_draft',
} as const;

export const INTERNAL_NETWORK_AD_TOOL_NAMES = new Set([
  INTERNAL_NETWORK_TOOL_NAMES.LIST_AD_ENTITIES,
  INTERNAL_NETWORK_TOOL_NAMES.GET_AD_ENTITY_DETAILS,
  INTERNAL_NETWORK_TOOL_NAMES.GET_AD_ENTITY_RELATIONSHIPS,
  INTERNAL_NETWORK_TOOL_NAMES.QUERY_AD_GRAPH,
]);

export function isInternalNetworkAdToolName(toolName: string): boolean {
  const normalized = toolName.replace(/_/g, '-').toLowerCase();
  return Array.from(INTERNAL_NETWORK_AD_TOOL_NAMES).some(
    (name) => name.replace(/_/g, '-').toLowerCase() === normalized,
  );
}

export function isInternalNetworkRemoteC2ToolName(toolName: string): boolean {
  return (
    toolName.replace(/_/g, '-').toLowerCase() ===
    INTERNAL_NETWORK_TOOL_NAMES.REMOTE_C2_COMMAND.replace(/_/g, '-')
  );
}
